import { Resolver } from 'react-hook-form';
import { emailField } from 'src/services/registration/registration.config';
import email from 'src/utils/validation/email';
import required from 'src/utils/validation/required';
import {
  validateFieldSync,
  validateFormSync,
} from 'src/utils/validation/validate-generators';

export const formConfigEmailRegistration = (Email: string) => {
  const initialValues = {
    [emailField]: Email,
  };

  const validate = validateFormSync({
    [emailField]: validateFieldSync(required, email),
  });

  const resolver: Resolver<any> = async (values: any) => {
    return {
      values: values,
      errors: validate(values),
    };
  };
  return { initialValues, resolver };
};
